import { WidgetState } from '@nirvana/shared/dtos/types/widgets/common';

export enum WidgetStateFrontEnd {
  IS_LOADING = 'is-loading',
  IS_ACTIVE = 'is-active',
  IS_EMPTY = 'is-empty',
  IS_ERROR = 'is-error',
  IS_INFO = 'is-info',
  IS_CHANGED = 'is-changed',
}

export const WidgetStateBackendToFrontEnd = new Map<WidgetState, WidgetStateFrontEnd>([
  [WidgetState.IS_EMPTY, WidgetStateFrontEnd.IS_EMPTY],
  [WidgetState.IS_ACTIVE, WidgetStateFrontEnd.IS_ACTIVE],
  [WidgetState.IS_ERROR, WidgetStateFrontEnd.IS_ERROR],
  [WidgetState.IS_INFO, WidgetStateFrontEnd.IS_INFO],
  [WidgetState.IS_LOADING, WidgetStateFrontEnd.IS_LOADING],
  [WidgetState.IS_CHANGED, WidgetStateFrontEnd.IS_CHANGED],
]);

export const WidgetStateFrontEndToBackend = new Map<WidgetStateFrontEnd, WidgetState>(
  Array.from(WidgetStateBackendToFrontEnd.entries()).map(([key, value]) => [value, key])
);

export enum WidgetEvents {
  TITLE_CLICKED = 'titleClicked',
  REMOVED = 'widgetRemoved',
  START_DRAG = 'widgetStartDrag',
  ACTION_CLICKED = 'widgetActionClicked',
  LOADED_COMPONENT = 'widgetLoadedComponent',
  UPDATED = 'widgetUpdated',
}

export enum AlignTitle {
  LEFT = 'align-title-left',
  CENTER = 'align-title-center',
}
